import React from "react"
import './style.scss'

const Arrows = ({onClick, isPrevious}) => {
  return (<div
    className={'bb-arrows-pager ' + (isPrevious ? "bb-arrows-pager-previous" : 'bb-arrows-pager-next')}>
    <div
      className={'bb-arrows ' + (isPrevious ? "pager-previous" : 'pager-next')}
      onClick={onClick}>
      <span
        className={"icon " + (isPrevious ? "bbicon-chevron-left" : "bbicon-chevron-right")}/>
    </div>
  </div>)
}

export default Arrows